import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import ReplayIcon from '@material-ui/icons/Replay';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { PAYMENT_STATUS, PAYMENT_TYPE } from 'src/models/PaymentModel';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { t } from 'src/lib/language';

const RetryPaymentButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );
  const lang = useSelector((state: Store) => state.language.language);

  const payments = useSelector(
    (state: Store) => selections.map(
      (id: number) => state.payments[id],
    ),
  );

  const { disabled } = props;

  const retryableStatuses = new Set([
    PAYMENT_STATUS.declined,
    PAYMENT_STATUS.error,
  ]);

  const isRetryablePayment = (payment: any) => {
    if (!payment) return false;
    const isOnline = [PAYMENT_TYPE.cc, PAYMENT_TYPE.eft].includes(payment.payment_type);
    if (!isOnline) return false;
    return retryableStatuses.has(payment.payment_status);
  };

  const isDisabled = () => (
    disabled || !payments.some(isRetryablePayment)
  );

  const handleOpen = () => {
    dispatch(openDialog({
      dialog: DIALOGS.retryPayments,
      payload: payments.filter(isRetryablePayment),
    }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.retry_payment')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={isDisabled()}>
            <ReplayIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default RetryPaymentButton;
